export type PermissionCheck = (permission: string) => boolean;

export const routePermissions: Record<string, string[]> = {
  "/speiseplanung": ["speiseplanung.view"],
  "/kueche": ["rezepte.view", "menu.view"],
  "/lager": ["lager.view", "lieferanten.view"],
  "/einkauf": ["einkauf.view", "budget.view", "wareneingang.view"],
  "/lmiv": ["lmiv.view", "kalorienref.view"],
  "/controlling": ["conusers.view", "conroles.view", "conmenu.view", "conrezepte.view", "conspeiseplanung.view", "conkalorienref.view", "conlager.view", "conlieferanten.view", "conwaste.view"],
  "/waste": ["waste.view", "waste.capture", "waste.kpi", "conwaste.view"],
  "/abrechnung": ["billing.view"],
  "/fuhrpark": ["fuhrpark.view"],
  "/it-service": ["ticketsystem.view", "workorder.view", "hardware.view"],
  "/vertraege": ["contracts.view"],
  "/administration": ["users.view", "roles.view", "settings.view"],
};

export function canOpenRoute(can: PermissionCheck, path: string) {
  const required = routePermissions[path] ?? [];
  return required.length === 0 || required.some(can);
}
